import React, { Component } from 'react';
import { withRouter } from "react-router";
import Styles from './styles.module.css';
import { IShopData } from '../../../Abstraction/IShopData';
import { shop } from '../../../Storage/shop';
import { Container, Row, Col } from 'reactstrap';
import MainTile from './MainTile';

@(withRouter as any)
export default class ShopDetails extends Component<{}, { shop: IShopData, selectedSize:string }>{
    constructor(props: any) {
        super(props);

        window.scrollTo({ behavior: 'auto', top: 0});
        
        const { match: { params: { id } } } = this.props as any;

        this.state = {
            shop: this.getShopDetails(id),
            selectedSize: ''
        };

        this.renderSizes = this.renderSizes.bind(this);
    }

    render() {
        return (
            <Container fluid className={Styles.container}>
                <Row noGutters>
                    <MainTile image={this.state.shop.image} />
                </Row>
                <Row className={Styles.row}>
                    <Col xs="12"><b className={Styles.titleHeader}>Title</b></Col>
                    <Col xs="12">
                        <p className={Styles.text}>{this.state.shop.title}</p>
                    </Col>
                </Row>
                <Row className={Styles.sizesContainer}>
                    <Col xs="12"><b className={Styles.titleHeader}>Sizes</b></Col>
                        {this.renderSizes()}
                </Row>
                <Row className={Styles.row}>
                    <Col xs="12"><b className={Styles.titleHeader}>Details</b></Col>
                    <Col xs="12">
                        <p className={Styles.text}>{this.state.shop.details}</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                        <button className={Styles.buy}>BUY NOW</button>
                    </Col>
                </Row>
            </Container>
        )
    }

    getShopDetails = (id: any) => {
        return shop.filter((x: IShopData) => x.id === Number(id))[0];
    }

    renderSizes(){
        const sizes:any[] = [];

        this.state.shop.sizes.forEach((size:string, index:number) => {
            const sizeSelect = (e:any) => {
                this.onSizeSelect(size);
            }

            sizes.push(
                <Col xs="12" md="auto" lg="auto">
                        <button className={this.state.selectedSize === size ? Styles.size + ' ' + Styles.active : Styles.size} onClick={sizeSelect}>{size}</button>
                </Col>
            );
        });

        return sizes;
    }

    onSizeSelect(size:string){
        this.setState({
            selectedSize: size
        })
    }
}